import PropTypes from 'prop-types';
import { widthPropType, aspectRatioPropType } from './common_types';

export const SourceImageSizeSpecType = {
  ONLY_WIDTH: 1,
  FIXED_ASPECT_RATIO: 2,
  VARIABLE_ASPECT_RATIO: 3
};

const onlyWidthSpecPropType = PropTypes.shape({
  widths: PropTypes.objectOf(widthPropType.isRequired).isRequired
});

const fixedAspectRatioSpecPropType = PropTypes.shape({
  widths: PropTypes.objectOf(widthPropType.isRequired).isRequired,
  aspectRatio: aspectRatioPropType.isRequired
});

const variableAspectRatioSpecPropType = PropTypes.shape({
  widths: PropTypes.objectOf(widthPropType.isRequired).isRequired,
  aspectRatios: PropTypes.objectOf(aspectRatioPropType.isRequired).isRequired
});

export const sourceImageSizeSpecPropType = PropTypes.oneOfType([
  onlyWidthSpecPropType,
  fixedAspectRatioSpecPropType,
  variableAspectRatioSpecPropType
]);
